import { stateOptions } from '../commonStateTaxData';

export const countyOptions = [
  { codeValue: 'allegany', shortName: 'Allegany County' },
  { codeValue: 'anne_arundel', shortName: 'Anne Arundel County' },
  { codeValue: 'baltimore_city', shortName: 'Baltimore City' },
  { codeValue: 'baltimore_county', shortName: 'Baltimore County' },
  { codeValue: 'calvert', shortName: 'Calvert County' },
  { codeValue: 'caroline', shortName: 'Caroline County' },
  { codeValue: 'caroll', shortName: 'Carroll County' },
  { codeValue: 'cecil', shortName: 'Cecil County' },
  { codeValue: 'charles', shortName: 'Charles County' },
  { codeValue: 'dorchester', shortName: 'Dorchester County' },
  { codeValue: 'frederick', shortName: 'Frederick County' },
  { codeValue: 'garrett', shortName: 'Garrett County' },
  { codeValue: 'harford', shortName: 'Harford County' },
  { codeValue: 'howard', shortName: 'Howard County' },
  { codeValue: 'kent', shortName: 'Kent County' },
  { codeValue: 'montgomery', shortName: 'Montgomery County' },
  { codeValue: 'prince_george', shortName: "Prince George's County" },
  { codeValue: 'queen_anne', shortName: "Queen Anne's County" },
  { codeValue: 'st_mary', shortName: "St. Mary's County" },
  { codeValue: 'somerset', shortName: 'Somerset County' },
  { codeValue: 'talbot', shortName: 'Talbot County' },
  { codeValue: 'washington', shortName: 'Washington County' },
  { codeValue: 'wicomico', shortName: 'Wicomico County' },
  { codeValue: 'worcester', shortName: 'Worcester County' },
];

export const basicInfoQuestions = [
  {
    id: 'employee_name',
    title: 'Employee name',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'employee_ssn',
    title: 'Social Security number',
    is_required: true,
    placeholder: '9 digits',
    question_type: 'identity',
    identity_type: 'ssn',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{9}$',
      },
    ],
  },
  {
    id: 'street_address',
    title: 'Street Address',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'city_or_town',
    title: 'City or town',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'county',
    title: 'County of residence \n (Nonresidents enter Maryland county (or Baltimore City) where you are employed.',
    is_required: true,
    question_type: 'dropdown',
    options: countyOptions,
  },
  {
    id: 'state',
    title: 'State',
    is_required: true,
    question_type: 'dropdown',
    options: stateOptions,
  },
  {
    id: 'zip_code',
    title: 'Zip code',
    is_required: true,
    question_type: 'short_text',
    placeholder: '5 digits',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{5}$',
      },
    ],
  },
  {
    id: 'federal_filing_status',
    title: 'What is your federal tax filing status?',
    is_required: true,
    question_type: 'dropdown',
    options: [
      {
        codeValue: 'single_or_married',
        shortName: 'Single or married filing separately',
      },
      {
        codeValue: 'married_or_widow',
        shortName: 'Married filing jointly or qualifying widow(er)',
      },
      {
        codeValue: 'head_of_household',
        shortName: 'Head of household',
      },
    ],
  },
];

export const getBasicInfoQuestions = (version = '03_23') => {
  if (version === '03_23') {
    const updatedQuestions = [...basicInfoQuestions];
    const filingStatusQuestion = updatedQuestions.find((q) => q.id === 'federal_filing_status');
    if (filingStatusQuestion) {
      filingStatusQuestion.options = [
        {
          codeValue: 'single',
          shortName: 'Single',
        },
        {
          codeValue: 'married',
          shortName: 'Married (surviving spouse or unmarried Head of Household) Rate',
        },
        {
          codeValue: 'married_but_single_rate',
          shortName: 'Married, but withhold at Single rate',
        },
      ];
    }
    return updatedQuestions;
  }

  return basicInfoQuestions;
};

// Calculation related questions
export const worksheetStatusQuestions = [
  {
    id: 'federal_income',
    title: 'What is your federal adjusted gross income?',
    is_required: true,
    question_type: 'dropdown',
    options: [
      {
        codeValue: 'lteq_100',
        shortName: '$100,000 or less',
      },
      {
        codeValue: 'gt_100_lteq_125',
        shortName: 'Greater than $100,000, but less than $125,000',
      },
      {
        codeValue: 'gt_125_lteq_150',
        shortName: 'Greater than $125,000, but less than $150,000',
      },
      {
        codeValue: 'gt_150_lteq_175',
        shortName: 'Greater than $150,000, but less than $175,000',
      },
      {
        codeValue: 'gt_175_lteq_200',
        shortName: 'Greater than $175,000, but less than $200,000',
      },
      {
        codeValue: 'gt_200',
        shortName: 'In excess of $200,000',
      },
    ],
  },
];

// Calculation related questions
export const worksheetShortTextQuestions = [
  {
    id: 'personal_exemptions_claimed',
    title:
      'Enter the number of personal exemptions you want to claim. Do not claim any personal exemptions you currently claim at another job, or any exemptions being claimed by your spouse. To qualify as your dependent, you must be entitled to an exemption for the dependent on your federal income tax return for the corresponding tax year \n \n NOTE: Dependent taxpayers may not claim themselves as an exemption.',
    is_required: true,
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
    ],
  },
  {
    id: 'additional_exemptions_age',
    title: 'Enter the number of additional exemptions you are claiming for dependents age 65 or over',
    is_required: false,
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
      {
        value: '100',
        action: 'lte',
        category: 'number',
      },
    ],
  },
  {
    id: 'itemized_deductions',
    title:
      'Enter the estimated amount of your itemized deductions (excluding state and local income taxes) that exceed the amount of your standard deduciton, alimony payments, allowable childcare expenses, qualified retirement contributions, business losses and employee business expenses for the year. Do not claim any additional amounts you currently claim at another job or any amounts being claimed by your spouse. \n \n NOTE: Standard deduction allowance is 15% of Maryland adjusted gross income with a minimum of $1,800 and a maximum of $2,700',
    is_required: false,
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
    ],
  },
  {
    id: 'additional_exemptions_spouse',
    title:
      'Enter the number of additional exemptions you are claiming for a taxpayer and/or spouse age 65 or over and/or blind.',
    is_required: false,
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
    ],
  },
  {
    id: 'additional_amt',
    title: 'Additional withholding per pay period under agreement with employer',
    is_required: false,
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
    ],
  },
];

export const domicileStateQuestion = [
  {
    id: 'domicile_state',
    title: 'Which state are you domiciled in?',
    is_required: true,
    question_type: 'dropdown',
    options: [
      {
        codeValue: 'DC',
        shortName: 'District of Columbia',
      },
      {
        codeValue: 'VA',
        shortName: 'Virginia',
      },
      {
        codeValue: 'WV',
        shortName: 'West Virginia',
      },
    ],
  },
];

export const stateOfResidenceQuestion = [
  {
    id: 'state_of_residence',
    title: 'Select your state of residence',
    is_required: true,
    question_type: 'dropdown',
    options: stateOptions,
  },
];

// Version 2025 Onwards
export const exemptionAndWithholdingQuestions = [
  {
    id: 'total_number_exemptions',
    title: 'Total number of exemptions you are claiming not to exceed line f in Personal Exemption Worksheet on page 2',
    is_required: false,
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
    ],
  },
  {
    id: 'additional_amt',
    title: 'Additional withholding per pay period under agreement with employer',
    is_required: false,
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
    ],
  },
];
